const u_GetUniqId = () => {
  return "_" + Math.random().toString(36).substr(2, 9);
}

const u_AddItemsToCart = async (items_to_add) => {
  // items_to_add = [{
  //   quantity: qty,
  //   id: variant_id,
  //   selling_plan: selling_plan_id,
  //   properties: {}
  // }]
  return await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ items: items_to_add })
  });
}

const u_RemoveCartItems = (removeItemsObj) => {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(removeItemsObj)
  });
}

const u_FormatMoney = (cents) => {
  return theme.formatMoney(cents, theme.moneyFormat)
}

const u_RemoveCartOutliers = async () => {
  let cart = await fetch('/cart.js?ts=' + Date.now()).then(res => res.json());

  // check cart if any outlier items are still present without their bundle partner, if so, remove them as well
  let removeItemsObj = {};
  cart.items.forEach(item => {
    if (item.properties && item.properties.__bundle_id) {
      let bundle_id = item.properties.__bundle_id;
      let has_bundle_partner = cart.items.some(cart_item => {
        return cart_item.properties && cart_item.properties.__bundle_id === bundle_id && cart_item.key !== item.key;
      });
      if (!has_bundle_partner) {
        console.log('Found outlier item, remove:', item);
        removeItemsObj[item.key] = 0;
      }
    }
  });
  
  if (Object.keys(removeItemsObj).length > 0) {
    // console.log('Remove outliers:', removeItemsObj);
    await u_RemoveCartItems({
      updates: removeItemsObj,
    });

    document.dispatchEvent(new CustomEvent('theme:cart:update', {bubbles: true}));
  }
}

document.addEventListener('alpine:init', () => {
  // remove any outlier items that may be present in cart on page load
  u_RemoveCartOutliers();

  Alpine.data('ProductForm', () => ({
    flags: {
      include_bulbs: false,
    },
    main_variant: null,
    selected_bulb: null,
    init() {
      this.main_variant = JSON.parse(this.$el.dataset.main_variant);
      this.InitWatchers();

      // 6-mar-26: set default to no bulb
      this.$nextTick(() => {
        this.$el.querySelector('[data-nobulb-option]').click();
      });

      // 6-mar-26: this is no longer needed atm, requested to default to no bulb
      // check if form has bulb addon select, if not, set flag to false to prevent errors when adding to cart
      // if (this.$el.querySelector('[data-option="bulbs"]')) {
      //   this.flags.include_bulbs = true;
      // }

      this.SetSelectedBulb();
    },

    InitWatchers() {
      this.$watch('flags.include_bulbs', this.UpdateTotalPrice.bind(this));
      this.$watch('selected_bulb', this.UpdateTotalPrice.bind(this));
    },

    // UpdateTotalPrice() {
    //   let price = this.main_variant.price;

    //   if (this.flags.include_bulbs && this.selected_bulb) {
    //     price += this.selected_bulb.price;
    //   }

    //   let $product = this.$el.closest('.form__wrapper');
    //   if (!$product) return;
    //   let $priceElem = $product.querySelector('[data-product-price]');
    //   if (!$priceElem) return;

    //    $priceElem.textContent = u_FormatMoney(price);
    //    console.log('Updated price:', price);
    //  },


    // Duplicated UpdateTotalPrice Function for trade prices
       UpdateTotalPrice() {
        let basePrice = this.main_variant.price;
        let bulbsTotal = 0;
        if (this.flags.include_bulbs && this.selected_bulb) {
          //price += this.selected_bulb.price;
          const qty = parseInt(document.getElementById('bulbs_qty').value) || 1;
          bulbsTotal = this.selected_bulb.price * qty;
        }
        let price = basePrice + bulbsTotal;
        let $product = this.$el.closest('.form__wrapper');
        if (!$product) return;
        let $priceElem = $product.querySelector('[data-product-price]');
        let $tradePriceElem = $product.querySelector('[data-trade-price]');
        if ($priceElem) {
          $priceElem.textContent = u_FormatMoney(price);
        }
        if($tradePriceElem){
           let tradeDiscount = parseFloat($tradePriceElem.dataset.tradeDiscount) || 0;
           let tradePrice =  (basePrice * (1 - tradeDiscount / 100)) + bulbsTotal;
           $tradePriceElem.textContent = u_FormatMoney(tradePrice);
        }

        // Update sticky cart-bar price too (separate DOM branch, not reachable via closest())
          let $cartBarPriceElem = document.querySelector('.cart-bar [data-product-price]');
          let $cartBarTradePriceElem = document.querySelector('.cart-bar [data-trade-price]');
          if ($cartBarPriceElem) {
            $cartBarPriceElem.textContent = u_FormatMoney(price);
          }
          if ($cartBarTradePriceElem) {
            let tradeDiscount = parseFloat($cartBarTradePriceElem.dataset.tradeDiscount) || 0;
            let tradePrice = (basePrice * (1 - tradeDiscount / 100)) + bulbsTotal;
            $cartBarTradePriceElem.textContent = u_FormatMoney(tradePrice);
          }
     },


    SetSelectedBulb(e) {
      let $form = e ? e.currentTarget.closest('.product__form__wrapper') : this.$el;
      let $bulbs = $form.querySelector('#select-bulb-addon');
      let $selected_bulb = $bulbs.querySelector('.select-popout__item--current .select-popout__option');
      let selected_bulb_variant = $selected_bulb ? JSON.parse($selected_bulb.dataset.bulb_variant) : null;  
      selected_bulb_variant.image_url = $selected_bulb ? $selected_bulb.dataset.bulb_image : null;
      this.selected_bulb = selected_bulb_variant;
    },

    e_SelectBulb(e) {
      this.flags.include_bulbs = true;
      this.SetSelectedBulb(e);
    },

    async e_AddToCartWithBulbs(e) {
      e.preventDefault();

      let $button_atc = e.currentTarget;
      let $form = $button_atc.closest('.product__form__wrapper');
      let $bulbs = $form.querySelector('#select-bulb-addon');
      let $selected_bulb = $bulbs.querySelector('.select-popout__item--current .select-popout__option');
      let selected_bulb_variant = $selected_bulb ? JSON.parse($selected_bulb.dataset.bulb_variant) : null;
      let qty = parseInt($form.querySelector('[name="quantity"]').value) || 1;
      let bundle_id = u_GetUniqId();
      let itemsToAdd = [];

      // main item
      let main_item = {
        quantity: qty,
        id: $form.querySelector('[name="id"]').value
      };

      let main_item_props = {};

      let preorderProps = () => { 
        return (window.defaultPreproduct) ? (window.PPlineItemProperties?.() || {}) : {} 
      }
      main_item_props = Object.assign(main_item_props, {
        __bundle_id: bundle_id,
        __addBulbs: 'true',
        __bulbPrice: selected_bulb_variant.price,
        __bulbQtyUnit: $selected_bulb.dataset.bulb_qty,
        __bulbVariantID: selected_bulb_variant.id,
        __bulbProducthandle: $selected_bulb.dataset.bulb_product_handle,
        ...preorderProps()
      });
      main_item.properties = main_item_props;

      itemsToAdd.push(main_item);

      // bulbs
      let bulbQty = qty * parseInt($selected_bulb.dataset.bulb_qty);
      itemsToAdd.push({
        quantity: bulbQty,
        id: selected_bulb_variant.id,
        properties: {
          __bundle_id: bundle_id
        }
      });

      // add loading state to button
      this.ButtonLoadingState($button_atc, true);

      // add items to cart
      await u_AddItemsToCart(itemsToAdd).then(res => res.json());

      // refresh cart
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));

      // reset button
      setTimeout(() => {
        this.ButtonLoadingState($button_atc, false);
      }, 500);
    },

    ButtonLoadingState($button_atc, isLoading) {
      if (!$button_atc) return;

      $button_atc.classList.toggle('is-loading', isLoading);
      if (isLoading) {
        $button_atc.setAttribute('disabled', 'disabled');
      } 
      else {
        $button_atc.removeAttribute('disabled');
      }
    }
  }));

  Alpine.data('RemoveItemWithBulbs', () => ({
    async e_RemoveItems(e) {
      // remove cart items
      let removeItemsObj = {};
      removeItemsObj[e.currentTarget.dataset.key] = 0;        
      if (e.currentTarget.dataset.bulb_key) {
        let bulb_key = e.currentTarget.dataset.bulb_key;
        if (bulb_key) {
          removeItemsObj[bulb_key] = 0;
        }
      }
      let res = await u_RemoveCartItems({
        updates: removeItemsObj,
      }).then(res => res.json());

      // if cart page, reload page
      if (window.location.pathname === '/cart') {
        window.location.reload();
      }

      // remove any outlier items that may be present in cart without their bundle partner, if so, remove them as well
      u_RemoveCartOutliers();

      // refresh cart
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
    }
  }));
});